import Print from '../scheleton/components/Print'

function ApplicationsButtons (props) {


    return (
        <>
            <div className='padding-standard'>
                    <div className='row greenBoxStyle'
                                onClick={() => window.open("https://kalk.vismus.pl?login=true", "_blank", "noopener noreferrer")}
                                style={{ cursor: "pointer" }}
                    >
                    <Print>calculator</Print>
                    </div>
            </div>
            <div className='padding-standard'>
                    <div className='row greenBoxStyle '
                                onClick={() => window.open("https://tracker.vismus.pl", "_blank", "noopener noreferrer")}
                                style={{ cursor: "pointer" }}
                    >
                    <Print>tracker</Print>
                    </div>
            </div>
        </>
    )
}

export default ApplicationsButtons;